/* Sofía Belmonte – Kaching Cart: alleen prijsnotatie 54,95€ en de regel onder de betaalicoontjes. Alle andere instellingen komen uit Kaching zelf. */
(function(){
  var PRICE=/-?€\s?(\d{1,3}(?:\.\d{3})*,\d{2})/g;
  function prices(root){
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null),n;
    while((n=w.nextNode())){
      var v=n.nodeValue;
      if(v.indexOf('€')>-1){ var nv=v.replace(PRICE,function(m,a){return (m.charAt(0)==='-'?'-':'')+a+'€';}); if(nv!==v) n.nodeValue=nv; }
    }
  }
  function apply(){
    var inner=document.querySelector('#kaching-cart .kaching-cart__inner'); if(!inner) return;
    var target=inner.querySelector('.kaching-cart__payment-icons')||inner.querySelector('.kaching-cart__checkout-button');
    if(target){
      var t=inner.querySelector('.sb-kc-note');
      if(!t){t=document.createElement('div');t.className='sb-kc-note';t.innerHTML='30 días para devolver<span>|</span>Pago 100% seguro';}
      if(target.nextElementSibling!==t) target.insertAdjacentElement('afterend',t);
    }
    prices(inner);
  }
  var queued=false;
  function schedule(){ if(queued) return; queued=true; requestAnimationFrame(function(){queued=false;apply();}); }
  function start(){ apply(); new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,characterData:true}); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
})();
